var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Paragraph from '../../Typography/Paragraph';
import Message from '../Message';
import * as styles from './style.module.css';
const PriorityZeroMessage = (_a) => {
    var { status, children, title, href } = _a, commonProps = __rest(_a, ["status", "children", "title", "href"]);
    const titleCopy = (React.createElement(Paragraph, { typeStyle: "body", as: "p", color: "base", fontWeight: "bold" }, title));
    const bodyCopy = (React.createElement(Paragraph, { typeStyle: "body", as: "p", color: "base", fontWeight: "regular" }, children));
    return href ? (React.createElement("a", Object.assign({}, commonProps, { href: href, target: "_blank", rel: "noreferrer", className: styles.link }),
        React.createElement(Message, { status: status, title: titleCopy, testId: "PriorityZeroMessage", withChevron: true, centerAlignedAtWiderWidth: true },
            bodyCopy,
            React.createElement("span", { className: styles.chevron })))) : (React.createElement(Message, Object.assign({}, commonProps, { status: status, title: titleCopy, testId: "PriorityZeroMessage", centerAlignedAtWiderWidth: true }), bodyCopy));
};
export default PriorityZeroMessage;
//# sourceMappingURL=index.js.map